import DocumentViewer from "../core/DocumentViewer";

export default DocumentViewer;



// WEBPACK FOOTER //
// ./app/javascript/components/preloaded/DocumentViewer.tsx